import { faUser, faWallet } from '@fortawesome/pro-regular-svg-icons';
import { faGift, faServer } from '@fortawesome/pro-solid-svg-icons';
import {
  type SideNavigationGroupItem,
  SideNavigationItemTypes,
} from '../../types';
import useNavigationData from './useNavigationData';
import useNavigationDataShared from './useNavigationDataShared';
import { CustomerFlag } from 'gportal-grpc/gportal/api/user/v1/customer_pb';

export default async () => {
  const { region } = useRegion();
  const { locale } = useI18n();

  const { communityMenuData } = useNavigationDataShared();

  const authStore = useAuthStore();

  // Build the account menu inside the computed so the LOOT_PASS check stays
  // reactive. hasCustomerFlag() reads activeCustomer, which is populated
  // asynchronously after login/recovery. The previous approach pushed the item
  // into a setup-time array, which froze it — the Loot Pass benefits link never
  // appeared until a full reload once the customer/flag finished loading.
  const profileMenuData = computed<SideNavigationGroupItem>(() => {
    const items: SideNavigationGroupItem['items'] = [
      {
        key: `${region.value}__my-servers`,
        label: 'general/menu/item/my_servers',
        icon: faServer,
        translate: true,
        type: SideNavigationItemTypes.LINK,
        data: {
          url: `/${region.value}/gamecloud`,
        },
      },
      {
        key: `${locale.value}__settings`,
        label: 'general/menu/item/settings',
        icon: faUser,
        translate: true,
        type: SideNavigationItemTypes.NUXT,
        data: {
          url: `/${locale.value}/profile`,
        },
      },
      {
        key: `${region.value}__payments`,
        label: 'account/payments/page/title',
        icon: faWallet,
        translate: true,
        type: SideNavigationItemTypes.NUXT,
        data: {
          url: `/${locale.value}/account/payments`,
        },
      },
    ];

    if (authStore.hasCustomerFlag(CustomerFlag.LOOT_PASS)) {
      items.push({
        key: `${region.value}__lootpass-benefits`,
        label: 'lootpass/breadcrumb',
        icon: faGift,
        translate: true,
        type: SideNavigationItemTypes.LINK,
        data: {
          url: `/${locale.value}/lootpass`,
        },
      });
    }

    return {
      key: `${region.value}__account`,
      label: 'general/menu/block/account',
      translate: true,
      items,
    };
  });

  const { productMenuData } = await useNavigationData();

  const firstLevelMenu = computed(() => ({
    uplink: null,
    items: [
      profileMenuData.value,
      productMenuData.value,
      communityMenuData.value,
    ],
  }));

  return {
    firstLevelMenu,
  };
};
